import { spacing, color } from '@upstox/upstox-ui';

export const details: CSSFunction = ({ cssProps: { paddingBottom } }) => ({
  width: '100% !important',

  // paddingBottom: paddingBottom ? 80 : 0,
  paddingBottom: 0,
  '@media (min-width:768px)': {
    paddingBottom: 80,
  },
});

export const applyWrapper: CSSFunction = ({ theme }) => ({
  position: 'fixed',
  bottom: 0,
  left: 0,
  right: 0,
  backgroundColor: color(theme, 'background.default'),
  padding: spacing(theme, ['medium']),
  borderTop: `1px solid ${color(theme, 'ui3')}`,
});

export const cardWrapper: CSSFunction = () => ({
  flexDirection: 'column-reverse',
  '@media(min-width:768px)': {
    flexDirection: 'row',
  },
});

export const ipoTimeline: CSSFunction = ({ theme }) => ({
  marginTop: spacing(theme, ['large']),
  '@media(min-width:768px)': {
    marginTop: spacing(theme, [44]),
  },
});

export const breadcrumb: CSSFunction = ({ theme }) => ({
  marginBottom: spacing(theme, ['xlarge']),
  marginTop: spacing(theme, ['medium']),
  '@media(min-width: 1024px)': {
    marginBottom: spacing(theme, [36]),
    marginTop: spacing(theme, ['xxlarge']),
  },
});
